import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { CompanyFilter } from '../model/company-filter';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {

  constructor( private dataService: DataService ) { }

  private readonly getCompanyFiltersEndPoint: string = '/company/getCompanyFilters/';

  async getCompanyFilters(): Promise<CompanyFilter[]> {
    const params = {  };
    return await this.dataService.get<CompanyFilter[]>
      (this.getCompanyFiltersEndPoint, params).toPromise();
  }
}
